import { FontAwesome5 } from '@expo/vector-icons';
import React from 'react';
import { TouchableOpacity } from 'react-native';

import { ml, flex } from '../../style-utils';
import { OEText } from '../oe-text/oe-text';

export type BackButtonProps = {
  onPress?: () => void;
  text?: string;
  accessibilityLabel?: string;
} & React.ComponentProps<typeof FontAwesome5>;

export function BackButton({
  onPress,
  text,
  accessibilityLabel,
  ...props
}: BackButtonProps) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[flex('flex-row', 'align-items-center')]}
      accessibilityLabel={accessibilityLabel}
    >
      <FontAwesome5 light name="arrow-left" {...props} />
      {text && (
        <OEText {...props} style={[ml(8)]}>
          {text}
        </OEText>
      )}
    </TouchableOpacity>
  );
}
